import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import classNames from 'classnames';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';
import { defaultContext, isAdmin } from '../services/account-service';

import styles from './composer/composer.module.css';

const Dashboard = () => {
  const user = useSelector((/** @type {Object} */ state) => state.user);
  const userAccount = useSelector((/** @type {Object} */ state) => state.account);
  const selectedAccount = useSelector((/** @type {Object} */ state) => state.selectedAccount);
  const account = selectedAccount || userAccount;
  const { _id: accountId } = account;

  const admin = isAdmin(userAccount);

  const renderAccountSelector = () => {
    return admin && !selectedAccount;
  };

  const hasComposerAccess = user.canReadComposer;
  const hasConsoleAccess = user.canRead;

  return renderAccountSelector() ? (
    <Redirect to="/select-account" />
  ) : (
    <div className={classNames(styles.pageCenter, styles.mt4)}>
      <h1 className={styles.h1}>Dashboard</h1>
      <div className={styles.pageColumns}>
        <div style={{ width: '70%' }} />
        <div style={{ width: '30%' }}>
          {(admin || hasComposerAccess) && (
            <div
              className={classNames(
                styles.rounded,
                styles.p,
                styles.pointer,
                styles.hoverLightBG,
                styles.hoverPurple,
                styles.mb,
                styles.flex
              )}
              tabIndex={-1}
              role="button"
              onClick={() => {
                document.location = '/composer';
              }}
            >
              <div className={classNames(styles.p, styles.lightBG, styles.rounded, styles.flex)}>
                <PlayCircleOutlineRoundedIcon />
              </div>
              <div>
                <div className={classNames(styles.strong)}>Stream Composer</div>
                <div className={classNames(styles.light)}>Configure video streams</div>
              </div>
            </div>
          )}
          {(admin || hasComposerAccess) && (
            <div
              className={classNames(
                styles.rounded,
                styles.p,
                styles.pointer,
                styles.hoverLightBG,
                styles.hoverPurple,
                styles.mb,
                styles.flex
              )}
              tabIndex={-1}
              role="button"
              onClick={() => {
                document.location = '/studio';
              }}
            >
              <div className={classNames(styles.p, styles.lightBG, styles.rounded, styles.flex)}>
                <ColorLensOutlinedIcon />
              </div>
              <div>
                <div className={classNames(styles.strong)}>Creative Studio</div>
                <div className={classNames(styles.light)}>Build creative templates</div>
              </div>
            </div>
          )}
          {(admin || hasConsoleAccess) && (
            <div
              className={classNames(styles.rounded, styles.p, styles.pointer, styles.hoverLightBG)}
              tabIndex={-1}
              role="button"
              onClick={() => {
                document.location = `/account/${accountId}/${defaultContext(account)}`;
              }}
            >
              <div className={classNames(styles.light, styles.px)}>Admin Console</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
